<template>

  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-row style="margin-top: 20px;">
        <el-col :span="20">
          <el-form label-width="120px" class="demo-formData">
            <el-form-item label="机构名称:">
              <span>{{formData.organizationName}}</span>
            </el-form-item>
            <el-form-item label="学员人数:">
              <span>{{formData.studentNum}}</span>
            </el-form-item>
            <el-form-item label="负责人:">
              <span>{{formData.userName}}</span>
            </el-form-item>
            <el-form-item label="联系电话:">
              <span>{{formData.phone}}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-form v-model="fooData" label-width="120px" class="demo-formData">
          <el-form-item label="财务状况:" style="text-align: center">
            <el-col :span="8">
              <el-form label-width="120px" class="demo-formData" >
                <div class="grid-content bg-purple">今日收入</div>
                <span>{{fooData.dayMoney}}</span>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form label-width="120px" class="demo-formData">
                <div class="grid-content bg-purple">本月收入</div>
                <span>{{fooData.monthMoney}}</span>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form label-width="120px" class="demo-formData">
                <div class="grid-content bg-purple">总收入</div>
                <span>{{fooData.countMoney}}</span>
              </el-form>
            </el-col>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <div class="incomeList">往月收入</div>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="100">
          </el-table-column>
          <el-table-column
            :formatter="formatDate"
            property="createTime"
            label="月份">
          </el-table-column>
          <el-table-column
            property="monthMoney"
            label="当月收入">
          </el-table-column>
          <el-table-column
            property="userCount"
            label="会员人数">
          </el-table-column>
        </el-table>
      </el-row>
    </div>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getInstitutionalDel } from "../api/api"
  export default {
    data(){
      return {
        tableData: [],
        formData: [],
        fooData:[],
        limit:20,
        currentPage:1,
        formLabelWidth: '120px',
      }
    },
    components: {
      headTop,
    },
    methods:{
      formatDate:function (value){
        var dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      //机构用户详情
      getInstitutionalDel(){
        let params={
          userId:this.$route.query.id,
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        getInstitutionalDel(params).then(res=>{
          this.formData = res.organization
          this.fooData = res.organizationUser
          this.tableData = res.list
        }).catch(error=>{
          console.log(error);
        })

      },
    },
    activated () {
      this.getInstitutionalDel()
    },
  }
</script>
<style>
  .incomeList{
    text-align: center;
    padding: 30px;
    font-size: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/page/intuserDetail.vue